import { FiEyeOff } from 'react-icons/fi';
import { AppTooltip } from './AppTooltip';

export const HiddenFinancialValue = ({ t, className = '' }) => {
  const label = t('Financial value hidden');
  return (
    <AppTooltip label={label}><span className={`inline-flex items-center gap-1.5 text-xs font-semibold text-[var(--text-muted)] ${className}`} aria-label={label}>
      <FiEyeOff className='h-4 w-4' aria-hidden='true' />
      <span>{t('Hidden')}</span>
    </span></AppTooltip>
  );
};
